var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9710_101514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 2.66602H2.66659C2.31296 2.66602 1.97382 2.80649 1.72378 3.05654C1.47373 3.30659 1.33325 3.64573 1.33325 3.99935V13.3327C1.33325 13.6863 1.47373 14.0254 1.72378 14.2755C1.97382 14.5255 2.31296 14.666 2.66659 14.666H11.9999C12.3535 14.666 12.6927 14.5255 12.9427 14.2755C13.1928 14.0254 13.3333 13.6863 13.3333 13.3327V8.66602",
    stroke: "#4A4A68",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 1.66617C12.5985 1.40095 12.9582 1.25195 13.3333 1.25195C13.7083 1.25195 14.068 1.40095 14.3333 1.66617C14.5985 1.93138 14.7475 2.29109 14.7475 2.66617C14.7475 3.04124 14.5985 3.40095 14.3333 3.66617L7.99992 9.9995L5.33325 10.6662L5.99992 7.9995L12.3333 1.66617Z",
    stroke: "#4A4A68",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9710_101514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d69f2edf3640f3de0ba374a981518c0c.svg";
export { ForwardRef as ReactComponent };